import {CountUp} from 'countup.js';

export default function Count(self) {
	// for each .js-count-up element
	document.querySelectorAll('.js-count-up').forEach((element) => {
		// get the target value
		const target = element.getAttribute('data-count-up');

		// create a new CountUp instance
		const countUpInstance = new CountUp(element, target, {
			enableScrollSpy: true,
			scrollSpyDelay: 300,
		});

		// start the CountUp animation
		countUpInstance.start();
	});
}
